import Vue from 'vue'
import Router from 'vue-router'
import Cookies from "js-cookie"
import Login from '@/views/Login'
import NotFound from '@/views/Error/404'
import Home from '@/views/Home'
import Intro from '@/views/Intro/Intro'
import Generator from '@/views/Generator/Generator'
import api from '@/http/api'
import store from '@/store'
import { getIFramePath, getIFrameUrl } from '@/utils/iframe'

Vue.use(Router)


/*
CRM 管理端暂不采用权限方式
*/
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'menu.menuHome',
      component: Home,
      children: [
        { 
          path: '', 
          name: 'menu.menuHome', 
          component: Intro,
          meta: {
            icon: 'fa fa-home fa-lg',
            index: 0
          }
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/404',
      name: 'notFound',
      component: NotFound
    }
  ]
})



router.beforeEach((to, from, next) => {
  //debugger
  // 登录界面登录成功之后，会把用户信息保存在会话
  // 存在时间为会话生命周期，页面关闭即失效。
  let token = localStorage.getItem('token') || sessionStorage.getItem('token') || (document.cookie.split(';').find(c => c.trim().startsWith('token=')) || '').split('=')[1]
  // 确保 token 是一个有效的值
  token = token && token.trim() ? token : null
  let userName = sessionStorage.getItem('user')
  if (to.path === '/login') {
    // 如果是访问登录界面，如果用户会话信息存在，代表已登录过，跳转到主页
    if(token) {
      next({ path: '/' })
    } else {
      next()
    }
  } else {
    if (!token) {
      // 如果访问非登录界面，且户会话信息不存在，代表未登录，则跳转到登录界面
      next({ path: '/login' })
    } else {
      // 加载动态菜单和路由

      addDynamicMenuAndRoutes(userName, to, from)
      next()
    }
  }
})

/**
* 加载动态菜单和路由
*/
function addDynamicMenuAndRoutes(userName, to, from) {
  // 处理IFrame嵌套页面
  console.log("to.path...................................")
  console.log(to.path)
  handleIFrameUrl(to.path)
  if(store.state.app.menuRouteLoaded) {
    console.log('动态菜单和路由已经存在.')
    return
  }


  debugger
  // 确保 Vue.prototype.distributor 存在
  if(!Vue.prototype.distributor) {
    console.log('distributor 未设置，使用默认值')
    Vue.prototype.distributor = ''
  }
  var distributor = Vue.prototype.distributor
  // userType ： 1管理员 ，2经销商
  // distributor 空的全部都有，有内容的限定  JAPAN ITALY_HINTIME ITALY SAU_EMS20 UBODY_EMS
  var menuDate = [
  {
    
    "parentId": 0,
    "id": 1,
    "name": "menu.menuManagementList",
    "url": null,      
    "type": 0,    
    "icon": "el-icon-s-grid",     
    "userType":[1,2],
    "distributor":[],
    "children": [
      { 
        "parentId": 1,
        "id": 102,       
        "name": "menu.menuAdministratorList",
        "url": "/user/managerList",       
        "type": 1,
        "icon": "el-icon-s-management",
        "userType":[1],
        "distributor":[],
        "children": []
      },
       { 
        "parentId": 1,
        "id": 1022,       
        "name": "menu.menuAgentList",
        "url": "/user/AgentList",       
        "type": 1,
        "icon": "el-icon-s-management",
        "userType":[1],
        "distributor":["ITALY_HINTIME","SAU_EMS20","MX_30FIT"],
        "children": []
      },
      { 
        "parentId": 1,
        "id": 1020,       
        "name": "menu.menuCoachList",
        "url": "/user/coachList",       
        "type": 1,
        "icon": "el-icon-user-solid",
        "userType":[1,2],
        "distributor":["ITALY_HINTIME","SAU_EMS20","MX_30FIT"],
        "children": []
      },
      { 
        "parentId": 1,
        "id": 1021,       
        "name": "menu.menuClientList",
        "url": "/user/userList",       
        "type": 1,
        "icon": "el-icon-s-custom",
        "userType":[1,2],
        "distributor":["ITALY_HINTIME","SAU_EMS20","MX_30FIT","EMS_ZAKAKOU"],
        "children": []
      },
       { 
        "parentId": 1,
        "id": 103,       
        "name": distributor != 'MX_30FIT' ?  "menu.menuProgramList" : "menu.menuProgramList_MX_30FIT",
        "url": "/user/modeList",       
        "type": 1,
        "icon": "el-icon-tickets",
        "userType":[1],
        "distributor":[],
        "children": []
      },
      { 
        "parentId": 1,
        "id": 105,       
        "name": distributor != 'MX_30FIT' ?  "menu.menuProgramGroupList" : "menu.menuProgramGroupList_MX_30FIT",
        "url": "/user/modeGroupList",       
        "type": 1,
        "icon": "el-icon-document-copy",
        "userType":[1],
        "distributor":["ITALY_HINTIME","SAU_EMS20","MX_30FIT","EMS_ZAKAKOU"],
        "children": []
      },
      { 
        "parentId": 1,
        "id": 10802,       
        "name": "menu.menuMembership",
        "url": "/user/Membership",       
        "type": 1,
        "icon": "el-icon-document-copy",
        "userType":[1],
        "distributor":["MX_30FIT"],
        "children": []
      },
      { 
        "parentId": 1,
        "id": 106,       
        "name": "menu.menuEnergyBoxList",
        "url": "/user/deviceControlList",       
        "type": 1,
        "icon": "el-icon-cpu",
        "userType":[1,2],
        "distributor":["ITALY_HINTIME","SAU_EMS20"],
        "children": []
      },
      {
        "parentId": 1,
        "id": 1080,       
        "name": "menu.menuSession",
        "url": "/user/sessionList",       
        "type": 1,
        "icon": "el-icon-wind-power",
        "userType":[1,2],
        "distributor":["SAU_EMS20"],
        "children": []
      }, 
      {
        "parentId": 1,
        "id": 1081,       
        "name": "menu.menuUserSession",
        "url": "/user/userSessionList",       
        "type": 1,
        "icon": "el-icon-s-claim",
        "userType":[1,2],
        "distributor":["SAU_EMS20"],
        "children": []
      },
      {
        "parentId": 1,
        "id": 1082,       
        "name": "menu.menuCoachTrainPlayStatics",
        "url": "/user/CoachTrainPlayStatics",       
        "type": 1,
        "icon": "el-icon-s-claim",
        "userType":[1,2],
        "distributor":["SAU_EMS20"],
        "children": []
      }, 
      

      {
        "parentId": 1,
        "id": 107,       
        "name": "menu.menuTraining",
        "url": "/user/trainRecordList",       
        "type": 1,
        "icon": "el-icon-s-data",
        "userType":[1,2],
        "distributor":["ITALY_HINTIME","SAU_EMS20","MX_30FIT","EMS_ZAKAKOU"],
        "children": []
      },      
       { 
        "parentId": 1,
        "id": 104,       
        "name": "menu.menuOTAList",
        "url": "/user/otaList",       
        "type": 1,
        "icon": "el-icon-brush",
        "userType":[1],
        "distributor":[],
        "children": []
      }
    ]
  }];

  // 只有admin有账号管理权限
  // if("admin"!= sessionStorage.getItem('user')){
  //   menuDate.splice(0,1)
  // }
  var needRemoveMenuUrl = [];

  var userStr = sessionStorage.getItem("user")
  var user = userStr ? JSON.parse(userStr) : null
  if(!user){
    sessionStorage.removeItem("user")
    Cookies.remove("token")
    // 避免在路由导航守卫中调用 router.push，导致无限循环
    return
  }
  Vue.prototype.loginUser = user
  console.log("router user",user)
  for(var i = menuDate.length-1 ; i >= 0 ; i--){
      if(menuDate[i].userType.indexOf(user.type) < 0 || (menuDate[i].distributor.length > 0 && menuDate[i].distributor.indexOf(distributor) < 0)){
          menuDate.splice(i,1)
          continue
      }
      for(var j = menuDate[i].children.length-1;j >=0 ; j--){
         if(menuDate[i].children[j].userType.indexOf(user.type) < 0 || (menuDate[i].children[j].distributor.length > 0 && menuDate[i].children[j].distributor.indexOf(distributor) < 0)){
            menuDate[i].children.splice(j,1)
        } 
      }

  }
  

  let dynamicRoutes = addDynamicRoutes(menuDate)
  // 处理静态组件绑定路由
  handleStaticComponent(router, dynamicRoutes)
  // 添加动态路由到路由表
  router.addRoutes([{
    path: '/',
    component: Home,
    children: dynamicRoutes
  }])
  // 保存加载状态
  store.commit('menuRouteLoaded', true)
  // 保存菜单树
  store.commit('setNavTree', menuDate)

  /*

  api.menu.findNavTree({'userName':userName})
  .then(res => {
    debugger
    //res.data=[]
    // 添加动态路由
    let dynamicRoutes = addDynamicRoutes(res.data)
    // 处理静态组件绑定路由
    handleStaticComponent(router, dynamicRoutes)
    router.addRoutes(router.options.routes)
    // 保存加载状态
    store.commit('menuRouteLoaded', true)
    // 保存菜单树
    store.commit('setNavTree', res.data)
  }).then(res => {
    api.user.findPermissions({'name':userName}).then(res => {
      // 保存用户权限标识集合
      store.commit('setPerms', res.data)
    })
  })
  .catch(function(res) {
  })*/
}

/**
 * 处理路由到本地直接指定页面组件的情况
 * 比如'代码生成'是要求直接绑定到'Generator'页面组件
 */
function handleStaticComponent(router, dynamicRoutes) {
  for(let j=0;j<dynamicRoutes.length; j++) {
    if(dynamicRoutes[j].name == '代码生成') {
      dynamicRoutes[j].component = Generator
      break
    }
  }
  // 避免路由重复
  dynamicRoutes.forEach(route => {
    const exists = router.options.routes[0].children.some(child => child.path === route.path)
    if(!exists) {
      router.options.routes[0].children.push(route)
    }
  })
}

/**
 * 处理IFrame嵌套页面
 */
function handleIFrameUrl(path) {
  // 嵌套页面，保存iframeUrl到store，供IFrame组件读取展示
  let url = path
  let length = store.state.iframe.iframeUrls.length
  for(let i=0; i<length; i++) {
    let iframe = store.state.iframe.iframeUrls[i]
    if(path != null && path.endsWith(iframe.path)) {
      url = iframe.url
      store.commit('setIFrameUrl', url)
      break
    }
  }
}

/**
* 添加动态(菜单)路由
* @param {*} menuList 菜单列表
* @param {*} routes 递归创建的动态(菜单)路由
*/
function addDynamicRoutes (menuList = [], routes = []) {
 var temp = []
 for (var i = 0; i < menuList.length; i++) {

   if (menuList[i].children && menuList[i].children.length >= 1) {
     temp = temp.concat(menuList[i].children)
   } else if (menuList[i].url && /\S/.test(menuList[i].url)) {
      menuList[i].url = menuList[i].url.replace(/^\//, '')
      // 创建路由配置
      var route = {
        path: menuList[i].url,
        component: null,
        name: menuList[i].name,
        meta: {
          icon: menuList[i].icon,
          index: menuList[i].id
        }
      }
      let path = getIFramePath(menuList[i].url)
      if (path) {
        // 如果是嵌套页面, 通过iframe展示
        route['path'] = path
        route['component'] = resolve => require([`@/views/IFrame/IFrame`], resolve)
        // 存储嵌套页面路由路径和访问URL
        let url = getIFrameUrl(menuList[i].url)
        let iFrameUrl = {'path':path, 'url':url}
        store.commit('addIFrameUrl', iFrameUrl)
      } else {
       try {
         // 根据菜单URL动态加载vue组件，这里要求vue组件须按照url路径存储
         // 如url="sys/user"，则组件路径应是"@/views/sys/user.vue",否则组件加载不到
         let array = menuList[i].url.split('/')
         let url = ''
         for(let i=0; i<array.length; i++) {
            // 保持路径的大小写一致，避免组件加载失败
            // 对于所有路径段，使用大写首字母，因为目录和文件都是大写首字母的
            url += array[i].substring(0,1).toUpperCase() + array[i].substring(1) + '/'
         }
         url = url.substring(0, url.length - 1)
         route['component'] = resolve => require([`@/views/${url}`], resolve)
       } catch (e) {}
     }
     routes.push(route)
   }
 }
 if (temp.length >= 1) {
   addDynamicRoutes(temp, routes)
 } else {
   console.log('动态路由加载...')
   console.log(routes)
   console.log('动态路由加载完成.')
 }
 return routes
}

export default router
